import styled from 'styled-components';
import { Button, Typography } from '@/components';
import { TextStyles } from '@/constants';
import { ButtonVariant } from '@/interfaces';

export const UnsubscribeAllWrapper = styled.div`
  padding: 0 31px;
  position: relative;
  min-height: 587px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  background: ${({ theme }) => theme.colors.pageBackground};

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    min-height: 640px;
  }
`;

export const PageTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 1'],
})`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  word-break: break-word;
  white-space: pre-line;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing[20]};

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    margin-bottom: ${({ theme }) => theme.spacing[24]};
    width: 720px;
  }

  span {
    color: ${({ theme }) => theme.colors.darkOrange};
  }
`;

export const UnsubscribeButton = styled(Button).attrs({
  variant: ButtonVariant.Primary,
  isPMTButton: true,
  truncate: true,
})`
  margin-bottom: ${({ theme }) => theme.spacing[8]};
`;

export const BackToMyParcelsButton = styled(Button).attrs({
  variant: ButtonVariant.Link,
})`
  padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[10]};
  word-break: break-word;
  text-align: center;
`;
